import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';
import myLoansFilters from './myLoansFilters/myLoansFilters';
import myLoansMobileFilters from './myLoansMobileFilters/myLoansMobileFilters';
import myLoansCard from './myLoansCard/myLoansCard';

import myLoansContextMenu from './myLoansContextMenu/myLoansContextMenu';
import myLoansModalsModule from './modals/modals';
import cadastralReferenceMobile from './cadastralReferenceMobile/cadastralReferenceMobile';

import myLoansComponent from './myLoans.component';
import myLoansService from './myLoans.service';

let myLoansModule = angular.module('myLoans', [
  uiRouter,
  myLoansFilters,
  myLoansMobileFilters,
  myLoansCard,
  myLoansContextMenu,
  myLoansModalsModule,
  cadastralReferenceMobile,
])

.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state(STATES.LOANS. MY_LOANS, {
      url: ROUTES.LOANS.MY_LOANS,
      component: 'myLoans',
      data: {
        requiresAuth: true,
      },
      resolve: {
        /* @ngInject */
        serviceClosed: (StatusAppCheckers) => StatusAppCheckers.isServiceClosed()
      }
    });
})

.service('myLoansService', myLoansService)

.component('myLoans', myLoansComponent)

.name;

export default myLoansModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoans.js